(() => {
  const init = () => {
    const root = document.querySelector('[data-formats-horizontal]');
    if (!root || root.dataset.linksReady) return;
    root.dataset.linksReady = 'true';
    const reveal = () => {
      const targets = {'#accrochage-alu': '#accrochage-alu', '#encadre-formats-installation-entretien': '#encadre-formats-installation-entretien'};
      const selector = targets[location.hash];
      if (!selector) return;
      const detail = root.querySelector(selector);
      if (!detail) return;
      detail.open = true;
      requestAnimationFrame(() => {
        detail.scrollIntoView({block: 'start', behavior: 'instant'});
        detail.querySelector('summary')?.focus({preventScroll: true});
      });
    };
    window.addEventListener('hashchange', reveal);
    root.addEventListener('click', event => {
      const link = event.target.closest('a');
      if (!link) return;
      const url = new URL(link.href, location.href);
      if (url.pathname === location.pathname && ['#accrochage-alu', '#encadre-formats-installation-entretien'].includes(url.hash)) reveal();
    });
    reveal();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

